import { useCurrentCustomerQuery } from "~/queries/finance/customers";

type AddressEstimation = {
  countryCode?: string;
  state?: string;
};

function _useEstimatedUserShippingAddress() {
  const estimatedUserAddress = ref<AddressEstimation | undefined>({
    countryCode: undefined, // Initialize as undefined to prevent hydration issues
  });

  // Safely initialize the country code on the client side
  onMounted(() => {
    const estimatedCountry = getEstimatedUserCountry();

    if (estimatedCountry && !estimatedUserAddress.value?.countryCode) {
      estimatedUserAddress.value = {
        ...estimatedUserAddress.value,
        countryCode: estimatedCountry,
      };
    }
  });

  const { data: customer } = useCurrentCustomerQuery();
  const customerDefaultShippingAddress = computed(() =>
    customer.value?.addresses.find((a) => a.isShippingAddress),
  );

  watch(
    customerDefaultShippingAddress,
    (newAddress) => {
      if (!newAddress) return;

      estimatedUserAddress.value = {
        countryCode: newAddress.countryCode,
        state: newAddress.state,
      };
    },
    {
      immediate: true,
    },
  );

  function setEstimatedUserAddress(address: AddressEstimation) {
    estimatedUserAddress.value = address;
  }

  return {
    estimatedUserAddress: readonly(estimatedUserAddress),
    setEstimatedUserAddress,
  };
}

// Shared state so that the initial address calculation is only done once
// and does not overwrite previously set values when used by different components
export default createGlobalState(_useEstimatedUserShippingAddress);
